export default __webpack_public_path__ + "static/media/cargo.b6382aee.png";